import { makeRequest } from 'utils/requestLogger';

export default (payload) =>
  makeRequest('put', `/api/roundtables/${payload.id}`, payload);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/updateRoundtable.js